module.exports = __webpack_public_path__ + "static/qut-e54b3aa864ae33430b0143a0a38f668d.jpg";